<template>
  <div class="box-table-footer d-flex-between">
    <div class="black-14">共 {{total}} 条</div>
    <div class="box-page-btn">
      <div class="iconfont icon-diyiye" v-if="page > 1" @click="handleFirstPage"></div>
      <div class="iconfont icon-diyiye disClick" v-else @click="handleFirstPage"></div>
      <div class="iconfont icon-shangyiye" v-if="page > 1" @click="handlePreviousPage"></div>
      <div class="iconfont icon-shangyiye disClick" v-else @click="handlePreviousPage"></div>
      <div class="box-page-current black-14"><input type="number" v-model="current_page" @change="handleCurrentChange" ></div>
      <div class="box-page-num black-14 disClick">/{{last_page}}页</div>
      <div class="iconfont icon-xiayiye disClick" v-if="page >= last_page" @click="handleNextPage"></div>
      <div class="iconfont icon-xiayiye" v-else @click="handleNextPage"></div>
      <div class="iconfont icon-zuihouyiye disClick" v-if="page >= last_page" @click="handleLastPage"></div>
      <div class="iconfont icon-zuihouyiye" v-else @click="handleLastPage"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    last_page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      current_page: this.page,
    };
  },
  methods: {
    handleCurrentChange() {
      if (this.current_page > this.last_page) {
        this.current_page = this.last_page;
        return;
      }
      this.emitPage();
      if (this.autoScroll) {
        scrollTo(0, 800);
      }
    },
    handleNextPage() {
      if (this.current_page >= this.last_page) {
        this.current_page = this.last_page;
        return;
      }
      this.current_page++;
      this.emitPage();
    },
    handlePreviousPage() {
      if (this.current_page <= 1) {
        this.current_page = 1;
        return;
      }
      this.current_page--;
      this.emitPage();
    },
    handleFirstPage() {
      this.current_page = 1;
      this.emitPage();
    },
     handleLastPage() {
      this.current_page = this.last_page;
      this.emitPage();
    },
    emitPage() {
      this.$emit("update:page", parseInt(this.current_page));
      this.$emit("pagination", { page: parseInt(this.current_page) });
    },
  },
};
</script>

<style scoped>
.box-table-footer {
  border-radius: 0 0 10px 10px;
  padding: 0 15px;
  align-items: center;
  height: 63px;
  background: #ffffff;
  border-top: 1px solid #f4f4f4;
}
.box-page-btn {
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  height: 31px;
}
.box-page-btn div {
  border-right: 1px solid #e5e5e5;
  line-height: 30px;
}
.box-page-btn div:last-child {
  border-right: 0;
}
.box-page-btn .iconfont {
  width: 32px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  color: #333333;
}
.box-page-current input {
  width: 70px;
  text-align: center;
}

.box-page-current input::-webkit-outer-spin-button,
.box-page-current input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.box-page-current input[type="number"] {
  -moz-appearance: textfield;
}
.box-page-num {
  padding: 0 8px;
}
</style>
